import { config, authHeader, handleHttpResponse } from '../helpers'

export const AdminService = {
  adminListClients,
  adminListAlertLogs,
  adminListOptInLogs,
  adminLabels,
  modifyLabels,
  restoreLabels,
  adminSendNotification
}

// List all users
function adminListClients(adminID, index, number, filters) {
  const { createdFrom = "", createdTo = "", activityFrom = "", activityTo = "", user = "", userInactive = "" } = filters

  const query = `{
    adminListClients (
      adminID: "${adminID}",
      index: ${index},
      number: ${number}
      ${ user ? `, user: ${JSON.stringify(user)}` : ''}
      ${ userInactive ? `, userInactive: ${userInactive}` : ''}
      ${ createdFrom ? `, createdFrom: "${createdFrom}"` : ''}
      ${ createdTo ? `, createdTo: "${createdTo}"` : ''}
      ${ activityFrom ? `, activityFrom: "${activityFrom}"` : ''}
      ${ activityTo ? `, activityTo: "${activityTo}"` : ''}
    ) {
      nbTotal
      nbFiltered
      lastPage
      nbPages
      clients {
        id
        email
        createdDate
        lastActivityDate
        clipod {
          id
        }
      }
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.adminListClients;
    });
  })
}


// List all alertLogs
function adminListAlertLogs(adminID, index, number, filters) {
  const { dateFrom = "", dateTo = "", channel = "", source = "", user = "" } = filters

  const query = `{
    adminListAlertLogs (
      adminID: "${adminID}",
      index: ${index},
      number: ${number}
      ${ user ? `, user: ${JSON.stringify(user)}` : ''}
      ${ dateFrom ? `, dateFrom: "${dateFrom}"` : ''}
      ${ dateTo ? `, dateTo: "${dateTo}"` : ''}
      ${ channel ? `, channel: "${channel}"` : ''}
      ${ source ? `, source: "${source}"` : ''}
    ) {
      nbTotal
      nbFiltered
      lastPage
      nbPages
      alertLogs {
        id
        date
        channels
        source
        message
        client {
          email
        }
      }
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.adminListAlertLogs;
    });
  })
}


// List all OptIns
function adminListOptInLogs(adminID, index, number, filters) {
  const { dateFrom = "", dateTo = "", optIn = "all", user = "" } = filters

  const query = `{
    adminListOptInLogs (
      adminID: "${adminID}",
      index: ${index},
      number: ${number}
      ${ user ? `, user: ${JSON.stringify(user)}` : ''}
      ${ dateFrom ? `, dateFrom: "${dateFrom}"` : ''}
      ${ dateTo ? `, dateTo: "${dateTo}"` : ''}
      ${ optIn != 'all' ? `, optIn: ${optIn}` : ''}
    ) {
      nbTotal
      nbFiltered
      lastPage
      nbPages
      optInLogs {
        id
        date
        optIn
        client {
          email
        }
      }
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.adminListOptInLogs;
    });
  })
}


// List Labels for selected page
function adminLabels(adminID, page) {
  const query = `{
    adminLabels (
      adminID: "${adminID}",
      page: "${page}"
    ) {
      labels {
        category
        name
        labelFR
        labelNL
        labelDE
      }
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.adminLabels;
    });
  })
}


// Mutation modify the labels
function modifyLabels(adminID, page, labels) {
  const query = `mutation {
    modifyLabels (
      adminID: "${adminID}",
      page: "${page}",
      labels: ${JSON.stringify(labels).replace(/"([^(")"]+)":/g,"$1:")}
    ) {
      status
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.modifyLabels;
    });
  })
}


// Restore the labels
function restoreLabels(adminID, page) {
  const query = `mutation {
    restoreLabels (
      adminID: "${adminID}"
      page: "${page}"
    ) {
      status
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.restoreLabels;
    });
  })
}


// Admin send notification
function adminSendNotification(adminID, subject, body) {
  const query = `{
    adminSendNotification (
      id: "${adminID}"
      subject: ${JSON.stringify(subject)}
      body: ${JSON.stringify(body.replace(/\n/g, "<br/>"))}
    ) {
      ok
    }
  }`

  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/graphql', ...authHeader() },
    body: query
  }

  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
    return handleHttpResponse(response)
    .then(data => {
      return data.adminSendNotification;
    });
  })
}